import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralize } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsDirectory, CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const CloseTemplateTaskBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { open, close } = useCommands();
    const {
        selectedCloseTemplateTaskCount = 0,
        closeTemplateTaskBulkDeadlineOptions,
        closeTemplateTaskBulkRoleOptions,
        closeTemplateTaskBulkStageOptions,
        closeTemplateTaskBulkEstimateOptions,
        onCloseTemplateTaskBulkDelete,
    } = options;

    const heading = `${selectedCloseTemplateTaskCount} ${pluralize("task", selectedCloseTemplateTaskCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {closeTemplateTaskBulkDeadlineOptions && (
                <CommandItem
                    keywords={["due", "due date", "set due"]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.CLOSE_TEMPLATE_TASK_BULK_DEADLINE,
                            options,
                        )
                    }
                >
                    Set due
                </CommandItem>
            )}
            {closeTemplateTaskBulkRoleOptions && (
                <CommandItem
                    keywords={[
                        "role",
                        "assignee",
                        "assign",
                        "preparer",
                        "reviewer",
                        "client",
                    ]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.CLOSE_TEMPLATE_TASK_BULK_ROLE,
                            options,
                        )
                    }
                >
                    Set role
                </CommandItem>
            )}
            {closeTemplateTaskBulkStageOptions && (
                <CommandItem
                    keywords={["stage", "close stage"]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.CLOSE_TEMPLATE_TASK_BULK_STAGE,
                            options,
                        )
                    }
                >
                    Set stage
                </CommandItem>
            )}
            {closeTemplateTaskBulkEstimateOptions && (
                <CommandItem
                    keywords={["estimate", "time", "duration"]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.CLOSE_TEMPLATE_TASK_BULK_ESTIMATE,
                            options,
                        )
                    }
                >
                    Set estimate
                </CommandItem>
            )}
            {onCloseTemplateTaskBulkDelete && (
                <CommandItem
                    keywords={["delete", "remove", "trash"]}
                    onSelect={() => {
                        close();
                        onCloseTemplateTaskBulkDelete();
                    }}
                >
                    Delete
                </CommandItem>
            )}
        </Command.Group>
    );
};
